/**
 * Canonical hook for briefing template list query.
 * Replaces inline LIST_BRIEFING_TEMPLATES in BriefingTemplateListPage.
 */

import { useQuery } from '@apollo/client/react';
import { gql } from '@apollo/client';

const LIST_BRIEFING_TEMPLATES = gql`
  query ListBriefingTemplates {
    listBriefingTemplates {
      briefingId
      name
      displayName
      description
      triggerEvent
      deliveryChannels
      contextVariableCount
      sectionCount
    }
  }
`;

export interface BriefingTemplate {
  briefingId: string;
  name: string;
  displayName: string;
  description: string;
  triggerEvent: string;
  deliveryChannels: string[];
  contextVariableCount: number;
  sectionCount: number;
}

interface ListBriefingTemplatesData {
  listBriefingTemplates: BriefingTemplate[];
}

export function useBriefingTemplates() {
  const { data, loading, error, refetch } =
    useQuery<ListBriefingTemplatesData>(LIST_BRIEFING_TEMPLATES);

  return {
    templates: data?.listBriefingTemplates ?? [],
    loading,
    error,
    refetch,
  };
}
